export const calendarModals = {
  common: {
    cancel: "Cancelar",
  },
  arrival: {
    title: "Regras do calendário",
    loading: "Carregando configurações…",
    daysTitle: "Dias de entrada e saída",
    canArrive: "Hóspedes podem chegar",
    canDepart: "Hóspedes podem sair",
    daysHint:
      "Com <b>tudo selecionado</b> não há restrições. Se você permitir entradas apenas na segunda-feira e saídas apenas no domingo, toda reserva durará exatamente uma semana.",
    summaryAny: "Hóspedes podem chegar e sair em qualquer dia",
    summaryArrival: "entrada em {n} de 7 dias",
    summaryDeparture: "saída em {n} de 7 dias",
    summaryRestricted: "Restrito: {detail}",
    cutoffTitle: "Fechar as vendas de hoje após um horário definido",
    cutoffToggle: "Fechar automaticamente as vendas para o mesmo dia",
    cutoffToggleHint: "Enquanto isso estiver desativado, você aceita check-ins para hoje a qualquer hora.",
    cutoffFrom: "A partir de",
    cutoffTz: "o horário da sua propriedade",
    cutoffTzNow: "lá são {time}",
    cutoffHintPre: "Todos os dias, às ",
    cutoffHintMid: " em ",
    cutoffHintPost:
      ", você deixará de receber reservas para esse mesmo dia. Os dias seguintes continuam abertos normalmente.",
    cutoffSummaryOn: "As vendas fecham todos os dias às {time}",
    cutoffSummaryOff: "Você aceita check-ins para hoje a qualquer hora",
    turnoverTitle: "Tempo de preparação",
    turnoverQuestion: "Quantas noites você precisa entre um hóspede e o próximo?",
    turnoverOptNone: "Nenhuma",
    nights: "{count} noite | {count} noites",
    custom: "Personalizado",
    customLabel: "Noites",
    customAside: "de cada lado, até 7",
    turnoverSummaryNone: "Hóspedes podem chegar no mesmo dia em que outro sai",
    turnoverSummarySet: "Mantenha {nights} entre um hóspede e o próximo",
    turnoverLegacySummaryAfter: "Hoje só se aplica após a saída · guarde para cobrir os dois lados",
    turnoverLegacySummaryBefore: "Hoje só se aplica antes da entrada · guarde para cobrir os dois lados",
    turnoverLegacyNoteAfter: "Esta regra vem da versão anterior e hoje só bloqueia após a saída, não antes da entrada. Ao guardar, será aplicada aos dois lados, e antes mostramos quantas noites vão fechar.",
    turnoverLegacyNoteBefore: "Esta regra vem da versão anterior e hoje só bloqueia antes da entrada, não após a saída. Ao guardar, será aplicada aos dois lados, e antes mostramos quantas noites vão fechar.",
    exampleLabel: "Exemplo",
    exampleCaption: "Uma reserva que chega no dia 15 e sai no dia 18",
    legendStay: "Estadia",
    legendPrep: "Preparação",
    legendFree: "À venda",
    turnoverMoveHint:
      "O bloqueio se move sozinho se as datas mudarem e desaparece se a reserva for cancelada.",
    impactClosePre: "Isso vai fechar ",
    impactClosePost: " nos seus canais.",
    impactOpenPre: "Isso vai abrir ",
    impactOpenPost: ".",
    impactRetry: "Pressione “Salvar regras” novamente para aplicar.",
    fallbackHost: "sua propriedade",
    saving: "Salvando…",
    applyYes: "Sim, aplicar",
    saveRules: "Salvar regras",
    loadError: "Não foi possível carregar as configurações.",
    saveSuccess: "Regras do calendário salvas e enviadas aos seus canais.",
    saveError: "Não foi possível salvar.",
    saveConfigError: "Não foi possível salvar as configurações.",
    linkedTitle: "Venda do apartamento inteiro",
    linkedSummaryOff: "Esta unidade é vendida sozinha",
    linkedSummaryOn: "Vende a casa inteira · inclui {count} quarto | Vende a casa inteira · inclui {count} quartos",
    linkedSummaryChild: "Faz parte de {parent}",
    linkedRooms: "{count} quarto | {count} quartos",
    linkedToggle: "Ativar como apartamento inteiro do anúncio",
    linkedToggleHint: "Para a unidade que aluga a casa inteira. Depois escolha quais quartos ela inclui.",
    linkedQuestion: "Quais quartos ela inclui?",
    linkedAll: "Marcar todos",
    linkedNone: "Desmarcar todos",
    linkedIsParent: "Já é vendido como apartamento inteiro",
    linkedGuests: "{count} hóspede | {count} hóspedes",
    linkedExampleCaption: "Reservam «{room}» do dia 19 ao 21",
    linkedExampleRoom: "Quarto 1",
    linkedLegendClosed: "Fecha sozinho",
    linkedHint: "E vice-versa: se reservarem o apartamento inteiro, todos os seus quartos são fechados. Se a reserva for cancelada ou mudar de datas, tudo reabre sozinho, também nos seus canais. Enquanto a reserva estiver de pé, esses fechamentos não podem ser abertos manualmente.",
    linkedChildPre: "Este quarto faz parte de ",
    linkedChildPost: ". Se ele for reservado, esse apartamento inteiro fecha nessas noites; e se reservarem o apartamento inteiro, este quarto fecha sozinho. Isso se altera nas regras do calendário do apartamento inteiro.",
    linkedConflicts: "Já existe {count} venda dupla entre o apartamento inteiro e seus quartos. Revise: | Já existem {count} vendas duplas entre o apartamento inteiro e seus quartos. Revise:",
    linkedNeedsRooms: "Marque pelo menos um quarto incluído no apartamento inteiro.",
    linkedSaveError: "Não foi possível salvar a venda do apartamento inteiro.",
    linkedAlertTitle: "«{unit}» passa a ser o apartamento inteiro",
    linkedAlertBody: "Se ela for reservada, os quartos que você marcar serão fechados automaticamente, aqui e nos seus canais (Booking, Airbnb…). E se qualquer um deles for reservado, esta unidade será fechada nessas noites. Se a reserva for cancelada, tudo reabre sozinho.",
    linkedPartialSave: "A venda do apartamento inteiro foi salva, mas as outras regras não. Tente novamente.",
  },
  weekend: {
    title: "Configurações de preço",
    subtitle: "Estas informações serão exibidas todas as noites, a menos que você personalize por data.",
    loading: "Carregando configurações…",
    plTitle: "Preços gerenciados pelo PriceLabs",
    plDesc1:
      "Esta propriedade tem a gestão dinâmica de preços ativa com o PriceLabs. Os preços são atualizados automaticamente com base na demanda, na temporada e na ocupação.",
    plDesc2: "Para alterar os preços de fim de semana, faça isso diretamente no seu painel do PriceLabs.",
    plOpen: "Abrir PriceLabs",
    basePriceTitle: "Preço base",
    basePriceLabel: "Por noite — aplicado todos os dias",
    customization: "Personalização",
    weekendPriceTitle: "Preço de fim de semana",
    toggleOff: "Desativar preço de fim de semana",
    toggleOn: "Ativar preço de fim de semana",
    appliesTo: "Aplica-se em:",
    weekendLabel: "Fim de semana",
    infoHint: "Será aplicado aos próximos <strong>500 dias</strong> nos dias selecionados.",
    disabledText: "Os dias de fim de semana usarão o preço base de",
    confirmTitle: "Desativar preço de fim de semana?",
    confirmDescPre: "Os dias voltarão ao preço base de",
    confirmDescPost: "automaticamente.",
    disabling: "Desativando…",
    confirmDisable: "Sim, desativar",
    saving: "Salvando…",
    saveChanges: "Salvar alterações",
    diffEqual: "igual ao base",
    diffUp: "+{pct}% vs base",
    diffDown: "{pct}% vs base",
    loadError: "Erro ao carregar as configurações de preço",
    disableSuccess: "Preço de fim de semana desativado. Os dias voltam ao preço base.",
    disableError: "Erro ao desativar o preço de fim de semana",
    saveSuccess: "Preços salvos com sucesso",
    saveError: "Erro ao salvar",
  },
};
